import { useState } from "react";
import FileList from "./FileList";
import PreviewPane from "./PreviewPane";
import Breadcrumb from "./Breadcrumb";
import FolderLoadingState from "./FolderLoadingState";
import FolderErrorBanner from "./FolderErrorBanner";

const STAGE_LABELS = {
  cma: "CMA",
  listings: "Listings",
  pending: "Pending",
  closed: "Closed",
};

export default function DocumentsTab({ deal, onDealChanged }) {
  const [selected, setSelected] = useState(null);
  const [crumbs, setCrumbs] = useState(null); // null until we know root

  // 1. Error state: folder couldn't be created
  if (deal.driveFolderError) {
    return (
      <div className="p-4">
        <FolderErrorBanner
          dealId={deal.createdat}
          error={deal.driveFolderError}
          onResolved={() => onDealChanged && onDealChanged()}
        />
      </div>
    );
  }

  // 2. Loading state: folder still being created (just after deal creation)
  if (!deal.driveFolderId) {
    return (
      <FolderLoadingState
        dealId={deal.createdat}
        onResolved={() => onDealChanged && onDealChanged()}
      />
    );
  }

  // Initialize crumbs once we have the root folder
  const rootCrumb = { id: deal.driveFolderId, name: deal.propertyaddress || "Deal folder" };
  const effectiveCrumbs = crumbs || [rootCrumb];
  const currentFolderId = effectiveCrumbs[effectiveCrumbs.length - 1].id;

  const handleNavigateInto = (folder) => {
    setCrumbs([...effectiveCrumbs, { id: folder.id, name: folder.name }]);
    setSelected(null);
  };
  const handleNavigateCrumb = (index) => {
    setCrumbs(effectiveCrumbs.slice(0, index + 1));
    setSelected(null);
  };

  return (
    <div className="flex h-[calc(100vh-200px)] border rounded overflow-hidden">
      <div className="flex flex-col flex-1 min-w-0">
        <div className="px-4 py-3 border-b flex items-center justify-between bg-gray-50">
          <div>
            <div className="font-semibold">📁 {deal.propertyaddress || "Deal folder"}</div>
            <div className="text-xs text-gray-500">in {STAGE_LABELS[deal.driveFolderLocation] || "Drive"}</div>
          </div>
          <a
            href={`https://drive.google.com/drive/folders/${deal.driveFolderId}`}
            target="_blank"
            rel="noreferrer"
            className="text-sm text-linkColor hover:underline"
          >
            Open in Drive ↗
          </a>
        </div>
        <Breadcrumb crumbs={effectiveCrumbs} onNavigate={handleNavigateCrumb} />
        <FileList
          folderId={currentFolderId}
          onSelect={setSelected}
          onNavigateInto={handleNavigateInto}
        />
      </div>
      {selected && (
        <div className="w-[55%] min-w-[400px]">
          <PreviewPane file={selected} onClose={() => setSelected(null)} />
        </div>
      )}
    </div>
  );
}
